import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';

const EmailCredsModal = ({ pan, emailCreds, onClose }) => {
  const [emailLogins, setEmailLogins] = useState([]);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [currentEdit, setCurrentEdit] = useState({ email: '', email_password: '', email_login_pid: '' });
  const [token, setToken] = useState(null);

  // Function to fetch email logins
  const fetchEmailLogins = async () => {
    const fetchedEmailLogins = [];

    try {
      for (const emailLoginId of emailCreds) {
        const response = await axios.get(`https://stage-apiplatform.finkraft.ai/api/meta/emaillogins/${emailLoginId}`);
        
        if (Array.isArray(response.data) && response.data.length > 0) {
          fetchedEmailLogins.push(response.data[0]);
        }
      }

      setEmailLogins(fetchedEmailLogins);
    } catch (error) {
      console.error('Error fetching email logins:', error);
    }
  };

  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    if (savedToken) {
      setToken(savedToken);
    }
    if (emailCreds.length > 0) {
      fetchEmailLogins(); // Call fetchEmailLogins when emailCreds changes
    }
  }, [emailCreds]);

  const columnDefs = [
    { headerName: "Email Login PID", field: "email_login_pid" },
    { headerName: "Workspace", field: "workspace" },
    { headerName: "Email", field: "email" },
    { headerName: "Email Password", field: "email_password" },
    { headerName: "Status", field: "status" },
    { headerName: "Last Run At", field: "last_run_at" },
    {
      headerName: "Action",
      cellRenderer: (params) => (
        <button  className='validate-btn' onClick={() => handleEdit(params.data)}>Edit</button>
      ),
    },
  ];

  const handleEdit = (data) => {
    setCurrentEdit({
      email: data.email,
      email_password: data.email_password,
      email_login_pid: data.email_login_pid,
    });
    setEditModalVisible(true);
  };

  const handleSave = async () => {
    try {
      await axios.put(`https://stage-apiplatform.finkraft.ai/api/meta/emaillogins/${currentEdit.email_login_pid}`, {
        email: currentEdit.email,
        email_password: currentEdit.email_password,
      },{
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
      setEditModalVisible(false);
      fetchEmailLogins();
    } catch (error) {
      console.error('Error updating email login:', error);
    }
  };

  return (
    <div className={`emailcreds-model-overlay`}>
      <div className="modal-content">
        <h3>Email Creds for PAN: {pan}</h3>
        <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
          <AgGridReact
            rowData={emailLogins}
            columnDefs={columnDefs}
          />
        </div>
        <button onClick={onClose}>Close</button>
      </div>

      {editModalVisible && (
        <div className="edit-modal">
          <div >
            <h4>Edit Email Credentials</h4>
            <div>
              <label>Email:</label>
              <input
                type="text"
                value={currentEdit.email}
                onChange={(e) => setCurrentEdit({ ...currentEdit, email: e.target.value })}
              />
            </div>
            <div>
              <label>Email Password:</label>
              <input
                value={currentEdit.email_password}
                onChange={(e) => setCurrentEdit({ ...currentEdit, email_password: e.target.value })}
              />
            </div>
            <button onClick={handleSave}>Save</button>
            <button onClick={() => setEditModalVisible(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailCredsModal;
